export default class ShowPassword {
  constructor(options) {
    const _defaults = {

    }
    this.defaults = Object.assign({}, _defaults, options);
  }

  init() {
    const helpTabsTriggers = $('.js-products-tabs-trigger li');

    helpTabsTriggers.on('click', function (e) {
      e.preventDefault();
      let targetTab = $(this).attr('id')

      let selfHelpTabsTriggers = $(this).parent().find('li');

      selfHelpTabsTriggers.removeClass('is-active');

      $(this).addClass('is-active');

      let container = $(this).parent().parent();

      container.find('.js-products-tab').removeClass('is-active');
      container.find('.js-products-tab[data-tab = ' + targetTab + ']').addClass('is-active');

    })
  }
}


// WEBPACK FOOTER //
// ./static/js/components/ProductsTabs.js